import {StreamQuality} from './types';

export const CHARACTER_LIMIT = 10_000;

// matches grid-responsive medium (grid.tokens.scss)
export const MIN_VIEWPORT_WIDTH = 767;
export const MIN_VIEWPORT_HEIGHT = 498;

// Interfaces constants
export const interfacesMargin = 16;
export const inMeetingDraggableInset = {
    left: interfacesMargin,
    right: interfacesMargin,
};
export const sidePanelWidth = interfacesMargin + 344 + interfacesMargin; //margins + content width
export const desktopToolbarWidth = 72;
export const sidePanelPlusDesktopToolbarWidth =
    sidePanelWidth + desktopToolbarWidth;
export const INITIAL_STREAM_QUALITY = StreamQuality.High;

// Stack in-meeting notification tooltips just under the side panels/modals.
export const TOOLTIP_Z_INDEX_BELOW_OVERLAYS =
    'calc(var(--media-components-z-index-side-panel) - 1)';

export const MainBreakoutRoomId = 'main';

export const KEYBOARD_EVENT_KEY = {
    enter: 'Enter',
    escape: 'Escape',
    arrowUp: 'ArrowUp',
    arrowDown: 'ArrowDown',
} as const;

export const DEFAULT_CHAT_INPUT_HEIGHT = 145;

export const MESSAGES_BOTTOM_OFFSET = 80;

export const EFFECTS_MANAGER_NAVIGATION_MOVE_DISTANCE = 45;

export const IN_MEETING_SELFVIEW_BUTTON_TRANSPARENCY = 0.75;
